import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { interval: Number }

  connect() {
    this.currentIndex = 0
    this.slideCount = this.containerTarget.children.length
    this.startAutoSlide()
  }

  disconnect() {
    this.stopAutoSlide()
  }

  startAutoSlide() {
    this.slideInterval = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopAutoSlide() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval)
    }
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slideCount
    this.slide()
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount
    this.slide()
  }

  slide() {
    const offset = this.currentIndex * -100
    this.containerTarget.style.transform = `translateX(${offset}%)`
  }

  // Pause auto-slide when hovering
  mouseEnter() {
    this.stopAutoSlide()
  }

  // Resume auto-slide when mouse leaves
  mouseLeave() {
    this.startAutoSlide()
  }
} 